import { r as registerInstance, h, g as getElement } from './index-6e9159ae.js';
import { d as dispatchNumberFormatEvent } from './format-common-8105bed5.js';
import './event-utils-92b13243.js';

const AtomicFormatCurrency = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.format = (value, languages) => {
      return value.toLocaleString(languages, {
        style: 'currency',
        currency: this.currency,
      });
    };
    this.error = undefined;
    this.currency = undefined;
  }
  componentWillLoad() {
    try {
      dispatchNumberFormatEvent((value, languages) => this.format(value, languages), this.host);
    }
    catch (error) {
      this.error = error;
    }
  }
  render() {
    if (this.error) {
      return (h("atomic-component-error", { element: this.host, error: this.error }));
    }
  }
  get host() { return getElement(this); }
};

export { AtomicFormatCurrency as atomic_format_currency };

//# sourceMappingURL=atomic-format-currency.entry.js.map